(function () {
    'use strict';

    angular
        .module('rms.common')
        .factory('SelectListFilterService', SelectListFilterService);

    function SelectListFilterService(SELECT_CONSTANT, lodash, $timeout) {
        return function (mem) {
            return {
                prepareSelected: prepareSelected,
                toggleSelectRow: toggleSelectRow,
                toggleSelectAll: toggleSelectAll,
                unselectAll: unselectAll,
                reconcileSelected: reconcileSelected,
            };

            function prepareSelected(res) {
                // get the datasource options schema, content
                var dataField = lodash.get(mem.options, 'grid.datasource.schema.data', 'data');
                mem.currentPage.total = res[dataField].length;

                if (mem.currentPage.total > 0) {
                    angular.forEach(res[dataField], function (val) {
                        var existedItem = lodash.find(mem.pageData.toolbar.selection.selected, function (item) {
                            return item.select_id == val.select_id;
                        });
                        if (typeof existedItem !== typeof undefined) {
                            val.selected = SELECT_CONSTANT.SELECTED;
                            mem.currentPage.selected.push(val);
                        } else {
                            val.selected = SELECT_CONSTANT.NOT_SELECTED;
                        }
                    });
                    resolveSelectAll();
                } else {
                    unselectAllInPage();
                }
            }

            function reconcileSelected(res) {
                var dataField = lodash.get(mem.options, 'grid.datasource.schema.data', 'data');
                var data = res[dataField];
                var count = res[dataField].length;
                var toolbarSelected = [];
                var currentPageSelected = [];
                if (count > 0) {
                    angular.forEach(data, function (row) {
                        var match = lodash.find(mem.pageData.toolbar.selection.selected, function (selection) {
                            return selection.select_id === row.select_id;
                        })

                       if (match !== undefined) {
                           row.selected = SELECT_CONSTANT.SELECTED;
                           toolbarSelected.push(row);
                           currentPageSelected.push(row);
                       } else {
                           row.selected = SELECT_CONSTANT.NOT_SELECTED;
                       }

                    });
                }
                mem.pageData.toolbar.selection.selected = toolbarSelected;
                mem.currentPage.selected = currentPageSelected;

                resolveSelectAll();
            }

            function toggleSelectRow(dataItem) {
                var preventSelectionOn = lodash.get(mem.pageData.toolbar.selection, 'prevent_selection_on', null);
                if (!(preventSelectionOn && dataItem[preventSelectionOn])) {

                    if (dataItem.selected === SELECT_CONSTANT.SELECTED) {
                        mem.pageData.toolbar.selection.selected.push(dataItem);
                        mem.currentPage.selected.push(dataItem);
                    } else {
                        var index = lodash.findIndex(mem.pageData.toolbar.selection.selected, function (item) {
                            return item.select_id == dataItem.select_id;
                        });
                        mem.pageData.toolbar.selection.selected.splice(index, 1);
                        var indexCurrentPage = lodash.findIndex(mem.currentPage.selected, function (item) {
                            return item.select_id == dataItem.select_id;
                        });
                        mem.currentPage.selected.splice(indexCurrentPage, 1);
                    }
                }
                resolveSelectAll();
                // handleBulkAction();
            }

            function toggleSelectAll() {
                switch (mem.pageData.toolbar.selection.selectAllFlag) {
                    case SELECT_CONSTANT.ALL:
                        // unselect all
                        $timeout(function() {
                            unselectAllInPage();
                        });

                        break;
                    case SELECT_CONSTANT.SOME:
                    case SELECT_CONSTANT.NONE:
                        // select all
                        selectAllInPage();
                        break;
                    default:
                        break;
                }
            }

            function handleBulkAction() {
                if (mem.pageData.use_bulk_action) {
                    
                    var is_bulk_open =  mem.pageData.bulk_action_active;
                    mem.pageData.bulk_action_active = mem.currentPage.selected.length > 0

                    if(!mem.pageData.bulk_action_active){
                        if(is_bulk_open) {
                            //has been closed, if have filters applied open it, if not set to false
                            mem.pageData.sidebar_active = (lodash.get(mem.pageData, 'filters.active_filters.applied.length', 0) > 0)
                        }
                    }else{
                        mem.pageData.sidebar_active = false;
                    }

                    $timeout(function () {
                        mem.pageData.grid.resize();
                    });
                }
            }

            function unselectAll() {
                unselectAllInPage();
            }

            function resolveSelectAll() {
                if (mem.currentPage.total == mem.currentPage.selected.length) {
                    if (mem.currentPage.total > 0) {
                        mem.pageData.toolbar.selection.selectAllFlag = SELECT_CONSTANT.ALL;
                    } else {
                        mem.pageData.toolbar.selection.selectAllFlag = SELECT_CONSTANT.NONE;
                    }

                } else {
                    if (mem.currentPage.selected.length > 0) {
                        mem.pageData.toolbar.selection.selectAllFlag = SELECT_CONSTANT.SOME;
                    } else {
                        mem.pageData.toolbar.selection.selectAllFlag = SELECT_CONSTANT.NONE;
                        unselectAll()
                    }
                }
                handleBulkAction();
            }

            function selectAllInPage() {
                var preventSelectionOn = lodash.get(mem.pageData.toolbar.selection, 'prevent_selection_on', null);
                angular.forEach(mem.pageData.grid.dataSource.data(), function (val) {
                    if (preventSelectionOn && val[preventSelectionOn]) {
                        return;
                    }

                    val.selected = SELECT_CONSTANT.SELECTED;
                    var existedItem = lodash.find(mem.pageData.toolbar.selection.selected, function (item) {
                        return item.select_id == val.select_id;
                    });
                    if (typeof existedItem === typeof undefined) {
                        mem.pageData.toolbar.selection.selected.push(val);
                        mem.currentPage.selected.push(val);
                    }
                });
                mem.pageData.toolbar.selection.selectAllFlag = SELECT_CONSTANT.ALL;

                handleBulkAction()

            }

            function unselectAllInPage() {
                angular.forEach(mem.pageData.grid.dataSource.data(), function (val) {
                    val.selected = SELECT_CONSTANT.NOT_SELECTED;
                    // var index = lodash.findIndex(mem.pageData.toolbar.selection.selected, function (item) {
                    //     return item.select_id == val.select_id;
                    // });
                    // if (index >= 0) {
                    //     mem.pageData.toolbar.selection.selected.splice(index, 1);
                    // }
                });
                mem.pageData.toolbar.selection.selected.splice(0, mem.pageData.toolbar.selection.selected.length); // temporary for now

                mem.currentPage.selected.splice(0, mem.currentPage.selected.length);
                mem.pageData.toolbar.selection.selectAllFlag = SELECT_CONSTANT.NONE;
                // scope.listFilterService.clearSelected();
                lodash.set(mem.pageData, 'toolbar.selection.select_all', false);
                handleBulkAction()

            }
        };
    }
})();
